/*
 * Copyright (c) 2018 - 2021, Zaphod Consulting BV, Christine Karman
 * This project is free software: you can redistribute it and/or modify it under the terms of
 * the Apache License, Version 2.0. You can find a copy of the license at
 * http://www.apache.org/licenses/LICENSE-2.0.
 */
import LocalizedStrings from 'react-localization';

export const strings =  new LocalizedStrings({
    nl:{
        blog: "Blog",
        titel:"Zaphod BV",
        home:"Home",
        Product: "Produkt",
        Services: "Diensten",
        About: "Over ons",
        letters:"Brieven",
        people:"Personen",
        locations:"Locaties",
        references:"Referenties",
        subjects:"Topics",
        admin:"Admin",
        login:"Login",
        pages:"Bladzijden",
        op_nummer:"Op nummer",
        op_datum:"Op datum",
        naar_nummer:"Ga naar nummer",
        search:"Zoek",
        vorige:"Vorige",
        next:"Volgende",
        op_voornaam:"Op voornaam",
        op_achternaam:"Op achternaam",
        geboren:"Geboren",
        overleden:"Overleden",
        brieven_van:"Brieven van",
        brieven_aan:"Brieven aan",
        meer:"Meer",
        nummer:"Nummer",
        to:"Aan",
        from:"Van",
        date:"Datum",
        chapter:"Hoofdstuk",
        page:"Pagina",
        content:"Inhoud",
        sender:"Afzender",
        recipient:"Ontvanger",
        location:"Plaats",
        remarks:"Opmerkingen"
    },
    en:{
        blog: "Blog",
        titel:"Zaphod BV",
        home:"Home",
        Product: "Product",
        Services: "Services",
        About: "About",
        letters:"Letters",
        people:"People",
        locations:"Locations",
        references:"References",
        subjects:"Topics",
        admin:"Admin",
        login:"Login",
        pages:"Pages",
        op_nummer:"By number",
        op_datum:"By date",
        naar_nummer:"Go to number",
        search:"Search",
        vorige:"Previous",
        next:"Next",
        op_voornaam:"By first name",
        op_achternaam:"By last name",
        geboren:"Birth date",
        overleden:"Deceased",
        brieven_van:"Letters from",
        brieven_aan:"Letters to",
        meer:"More",
        nummer:"Number",
        to:"To",
        from:"From",
        date:"Date",
        chapter:"Chapter",
        page:"Page",
        content:"Content",
        sender:"Sender",
        recipient:"Recipient",
        location:"Location",
        remarks:"Remarks"
    },
    fr: {
        blog: "Blog",
        Product: "Produit",
        Services: "Services",
        About: "Á propos",
        titel:"Zaphod BV",
        home:"Accueil",
        letters:"Lettres",
        people:"Personnes",
        locations:"Villes",
        references:"Références",
        subjects:"Topics",
        admin:"Admin",
        login:"Login",
        pages:"Pages",
        op_nummer:"Par nombre",
        op_datum:"Par date",
        naar_nummer:"Aller au numéro",
        search:"Rechercher",
        vorige:"Précédente",
        next:"Suivante",
        op_voornaam:"Par prénom",
        op_achternaam:"Par nom de famille",
        geboren:"Date de naissance",
        overleden:"Décédé",
        brieven_van:"Lettres de",
        brieven_aan:"Lettres á",
        meer:"Plus",
        nummer:"Nombre",
        to:"À",
        from:"De",
        date:"Date",
        chapter:"Chapitre",
        page:"Page",
        content:"Contenu",
        sender:"Expéditrice",
        recipient:"Destinataire",
        location:"Ville",
        remarks:"Remarques"
    },
    de: {
        blog: "Blog",
        Product: "Produkt",
        Services: "Dienstleistungen",
        About: "Über uns",
        titel:"Zaphod BV",
        home:"Startsite",
        letters:"Briefe",
        people:"Personen",
        locations:"Orte",
        references:"Referenzen",
        subjects:"Topics",
        admin:"Admin",
        login:"Login",
        pages:"Seite",
        op_nummer:"Nach Nummer",
        op_datum:"Nach Datum",
        naar_nummer:"Gehe zu Nummer",
        search:"Suchen",
        vorige:"Vorherige",
        next:"Nächste",
        op_voornaam:"Nach Vorname",
        op_achternaam:"Nach Nachnamen",
        geboren:"Geburtsdatum",
        overleden:"Verstorben",
        brieven_van:"Briefe von",
        brieven_aan:"Briefe nach",
        meer:"Mehr",
        nummer:"Nummer",
        to:"An",
        from:"Von",
        date:"Datum",
        chapter:"Kapitel",
        page:"Seite",
        content:"Inhalt",
        sender:"Absender",
        recipient:"Empfanger",
        location:"Ort",
        remarks:"Bemerkungen"
    }
});

export default strings;
